import { render, staticRenderFns } from "./access-control-events.vue?vue&type=template&id=5cf68b40&scoped=true&"
import script from "./access-control-events.vue?vue&type=script&lang=ts&"
export * from "./access-control-events.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf68b40",
  null
  
)

export default component.exports